import { TranslationKey, useTranslations } from '@lang';
import { useWizardNavigation } from '../../contexts';

export const useNextStepLabel = (stepLabelKey: TranslationKey = 'spa.package.nextStep') => {
  const { t } = useTranslations();
  const { isLastStep } = useWizardNavigation();

  return isLastStep ? t('product.ctaButton') : t(stepLabelKey);
};
